import './IntegrationStatus.css';

interface Integration {
  name: string;
  description: string;
  status: 'connected' | 'disconnected' | 'degraded';
  lastSync: string;
}

export const IntegrationStatus = () => {
  // Static for Phase 2, will be dynamic in Phase 3
  const integrations: Integration[] = [
    {
      name: 'SaaScada',
      description: 'Core Banking',
      status: 'connected',
      lastSync: '30s ago',
    },
    {
      name: 'Clowd9',
      description: 'Card Management',
      status: 'connected',
      lastSync: '1m ago',
    },
    {
      name: 'Oscilar',
      description: 'Financial Crime',
      status: 'connected',
      lastSync: '45s ago',
    },
    {
      name: 'Uqudo',
      description: 'Identity Verification',
      status: 'connected',
      lastSync: '2m ago',
    },
  ];

  const getStatusIcon = (status: Integration['status']): string => {
    const icons: Record<Integration['status'], string> = {
      connected: '✅',
      disconnected: '❌',
      degraded: '⚠️',
    };
    return icons[status];
  };

  const getStatusLabel = (status: Integration['status']): string => {
    const labels: Record<Integration['status'], string> = {
      connected: 'Connected',
      disconnected: 'Disconnected',
      degraded: 'Degraded',
    };
    return labels[status];
  };

  return (
    <div className="integration-status-card">
      <h3 className="integration-status-title">🔗 System Integrations Status</h3>
      
      <div className="integration-list">
        {integrations.map((integration) => (
          <div key={integration.name} className="integration-item">
            <div className="integration-info">
              <div className="integration-name-row">
                <span className="integration-name">{integration.name}</span>
                <span className="integration-description">({integration.description})</span>
              </div>
              <div className="integration-status-row">
                <span className={`integration-status status-${integration.status}`}>
                  {getStatusIcon(integration.status)} {getStatusLabel(integration.status)}
                </span>
                <span className="integration-sync">Last sync: {integration.lastSync}</span>
              </div>
            </div>
            <button className="integration-refresh-btn" title="Refresh">
              🔄
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

